import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaQuestion } from "react-icons/fa";
import faq from "../assets/img/faq.jpg";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState<string | null>(null);
  const Faqs = useSelector((state: RootState) => state.Faq.faqs);

  // Function to toggle the visibility of the FAQ answer
  const toggleFAQ = (faqId: string) => {
    setActiveIndex(activeIndex === faqId ? null : faqId);
  };

  return (
    <div className="w-full p-4 py-20 bg-white">
      <h2 className="text-xl md:text-3xl font-bold mb-11 text-center flex justify-center items-center gap-1">
        Frequently Asked Questions
        <FaQuestion className="text-primary animate-pulse" />
      </h2>
      <img
        src={faq}
        alt="FAQ"
        className="w-[40%] md:w-[20%] mx-auto mb-5 rounded-lg"
      />

      {/* FAQ List */}
      <div className="space-y-4">
        {Faqs.map((faq) => (
          <motion.div
            key={faq.$id} // Use $id instead of id
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="border rounded-lg shadow-lg hover:shadow-xl"
          >
            {/* FAQ Question Button */}
            <button
              onClick={() => toggleFAQ(faq.$id)} // Use $id instead of id
              className="w-full px-4 py-3 text-left flex justify-between items-center focus:outline-none"
            >
              <span className="text-lg font-medium">{faq.question}</span>
              <span>{activeIndex === faq.$id ? "-" : "+"}</span>
            </button>
            {/* FAQ Answer */}
            {activeIndex === faq.$id && (
              <div className="px-4 py-7 bg-gray-50">
                <p className="text-base">{faq.answer}</p>
              </div>
            )}
          </motion.div>
        ))}
      </div>

      <h2 className="mt-10 text-lg md:text-2xl font-semibold">
        Have a Question? Ask Us Now!
      </h2>
    </div>
  );
};

export default Faq;
